export const appBarHeight = 64;


export const styles = theme => ({
  root: {
    width: '100%'
  },
  table: {
    minWidth: 500
  },
  iconContainer: {
    minWidth: 75
  },
  button: {
    background: 'transparent',
    boxShadow: 'none',
    color: '#8CA0B3',
    fontSize: 14,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  addButton: {
    background: 'transparent',
    boxShadow: 'none',
    color: '#2797E8 ',
    fontSize: 14,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  avatar: {
    margin: 15,
    width: 70,
    height: 70
  },
  title: {
    color: '#697B8C',
    fontWeight: 700
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  spacer: {
    flexGrow: 1
  },
  rowText: {
    color: '#8CA0B3',
    fontSize: 14,
    paddingRight: 5
  },
  select: {
    width: '30%',
    marginTop: 20,
    maxWidth: 500,
    marginRight: theme.spacing(2)
  },
  selectRows: {
    width: '30%',
    maxWidth: 500,
    marginRight: theme.spacing(2)
  },
  avatarCell: {
    paddingLeft: 50,
    paddingRight: 30
  },
  actions: {
    display: 'inline-flex',
    justifyContent: 'cemter',
    alignItems: 'center',
    paddingRight: 20
  },

  serarchInput: {
    marginLeft: 10
  },
  dialogTitle: {
    fontWeight: 'bold',
    fontSize: 20,
    padding: 20,
    paddingRight: 150,
    paddingBottom: 2,
    color: '#697B8C'
  },
  wrapDivider: {
    justifyContent: 'center'
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
    width: '95%'
  },
  input: {
    width: '100%',
    marginTop: 20
  },
  labelInput: {
    color: '#8CA0B3 !important',
    fontSize: 18
  },
  labelInputFile: {
    color: '#697B8C',
    fontSize: 14,
    marginTop: 30
  },
  textInput: {
    color: '#697B8C',
    fontWeight: 500,
    width: '100%',
    fontSize: 14
  },
  inputFileButton: {
    marginTop: 20,
    marginBottom: 20
  }
});

/*
  serarchText: {
    color: '#8CA0B3',
    fontSize: 14
  },

*/
